import React, { useState } from 'react'

import style from './ResetButton.module.css'

import { ReactComponent as ResetIcon } from 'assets/icons/reset-icon.svg'
import { ConfirmModal, IconButton } from 'common/components'
import { useAppDispatch, useAppSelector } from 'common/hooks'
import { selectActivityData, resetActivity } from 'features/dashboard'

export const ResetButton = () => {
  const dispatch = useAppDispatch()
  const [isResetModalOpen, setIsResetModalOpen] = useState(false)
  const activityData = useAppSelector(selectActivityData)

  const isNewbie = activityData.every(category => category.activities.attempts === 0)

  const resetResultsHandler = () => {
    dispatch(resetActivity())
  }

  return (
    <>
      <IconButton
        callback={() => setIsResetModalOpen(true)}
        title="Сбросить результат"
        disabled={isNewbie}
      >
        <ResetIcon className={style['info-icon']} />
      </IconButton>
      <ConfirmModal
        title="Сброс результатов"
        isOpen={isResetModalOpen}
        message="Вы уверены, что хотите сбросить результаты всех тренировок?"
        onClose={() => setIsResetModalOpen(false)}
        callback={resetResultsHandler}
      />
    </>
  )
}
